// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"7ae75887","92":"2d051a4d","99":"92314d14","215":"3342aa5b","337":"8d032a33","443":"50ac8908","453":"37d77375","479":"dfb82ea0","531":"2c8243c1","952":"8fa718bf"}[chunkId] + ".chunk.js";
};